// extracted by mini-css-extract-plugin
export default {"main":"NotFound_main__IBAJM","imageCont":"NotFound_imageCont__wtZGa","text":"NotFound_text__NWOfT","btn":"NotFound_btn__i6AKB"};